import { createBrowserRouter } from "react-router-dom";
import AllStudents from "../Dashboard/AllStudents/AllStudents";
import Courses from "../Dashboard/Courses/Courses";
import DashboardHome from "../Dashboard/DasboardHome/DashboardHome";
import Enrolling from "../Dashboard/EnrollingRequest/Enrolling";
import AddABlog from "../Dashboard/MyBlogs/AddBlog/AddABlog";
import Blogs from "../Dashboard/MyBlogs/AllBlog/Blogs";
import PublishCourse from "../Dashboard/PublishCourse/PublishCourse";
import DashboardLayout from "../Layouts/DashboardLayout";
import Main from "../Layouts/Main";
import BlogDetails from "../Pages/Home/Blogs/BlogDetails";
import Contact from "../Pages/Home/Contact/Contact";
import ContactPage from "../Pages/Home/Contact/ContactPage";
import AllCourse from "../Pages/Home/Courses/AllCourse";
import CourseDetails from "../Pages/Home/Courses/CourseDetails";
import Home from "../Pages/Home/Home/Home";
import Admission from "../Pages/Registration/Admission";
import Login from "../Pages/Registration/Login";
import Signup from "../Pages/Registration/Signup";
import StudentProfule from "../Pages/StudentProfile/StudentProfule";
import AdminRoute from "./AdminRoute";


const routes = createBrowserRouter([
    {
        path: '/',
        element: <Main />,
        children: [
            {
                path: '/',
                element: <Home />
            },
            {
                path: 'contact',
                element: <ContactPage />
            },
            {
                path: '/coursedetails/:id',
                loader: ({ params }) => fetch(`${process.env.REACT_APP_API_URL}/cpcourses/${params.id}`),
                element: <CourseDetails />
            },
            {
                path: 'admission',
                element: <Admission />
            },
            {
                path: '/signup',
                element: <Signup />
            },
            {
                path: 'signin',
                element: <Login />
            },
            {
                path: 'allcourse',
                element: <AllCourse />
            },
            {
                path: 'profile',
                element: <StudentProfule />
            },
            {
                path: '/blogdetails/:id',
                element: <BlogDetails />,
                loader: ({ params }) => fetch(`${process.env.REACT_APP_API_URL}/detailsblog/${params.id}`)
            },

        ]
    },
    {
        path: '/dashboard',
        element: <AdminRoute><DashboardLayout /></AdminRoute>,
        children: [
            {
                path: '/dashboard',
                element: <AdminRoute><DashboardHome /></AdminRoute>
            },
            {
                path: '/dashboard/courses',
                element: <AdminRoute><Courses /></AdminRoute>
            },
            {
                path: '/dashboard/postacourse',
                element: <AdminRoute><PublishCourse /></AdminRoute>
            },
            {
                path: '/dashboard/students',
                element: <AdminRoute> <AllStudents /></AdminRoute>
            },
            {
                path: '/dashboard/blogs',
                element: <AdminRoute><Blogs /></AdminRoute>
            },
            {
                path: '/dashboard/addblog',
                element: <AdminRoute> <AddABlog /></AdminRoute>
            },
            {
                path: '/dashboard/enrolling',
                element: <AdminRoute> <Enrolling /></AdminRoute>
            }
        ]
    }
])

export default routes;

// echo "# computerplus-client" >> README.md
// git init
// git add README.md
// git commit -m "first commit"
// git branch -M main
// git remote add origin https://github.com/jayed-phero/computerplus-client.git
// git push -u origin main